export const countriesListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Name',
    sortable: false,
  },
  {
    name: 'riskScore',
    label: 'Risk Score',
    sortable: false,
  },
  {
    name: 'alpha3',
    label: 'Alpha3',
    sortable: false,
  },
  {
    name: 'alpha2',
    label: 'Alpha2',
    sortable: false,
  },
  {
    name: 'numeric',
    label: 'ISO',
    sortable: false,
  },
  {
    name: 'active',
    label: 'Status',
    sortable: false,
  },
];

export const countriesListColumnsLabels = {
  name: 'Name',
  alpha3: 'Alpha3',
  alpha2: 'Alpha2',
  numeric: 'ISO',
  status: 'Status',
};

export const countriesListDefaultSorter = {};

export const countriesListSchema = {};

export const countriesListFiltersSchema = [];
